import React from "react";
import AdminLayout from "../AdminLayout";
import ContactsSection from "./ContactsSection";

const Contacts = () => {
  return (
    <AdminLayout
      selectedMenuItem="Contacts"
      pageTitle="Client Inquiries"
      pageSubtitle="Scan incoming messages faster with more whitespace, stronger contrast, and a calmer layout."
    >
      <ContactsSection />
    </AdminLayout>
  );
};

export default Contacts;
